<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog modal-dialog-centered modal-lg w-100" role="document">
      <div class="modal-content radius-8">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="modal-title" id="sizeGuideModalLabel">{{ customer.translations.quota_limit_exceeded_title }}</h5>

          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body p-0 my-3">
          <div class="text-center">
            <p class="alert-text m-0">{{ customer.translations.quota_limit_exceeded_message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      customer: {
        type: Object,
        required: true
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      }
    }
  };
</script>
